// removed by extract-text-webpack-plugin
module.exports = {"main":"InlineButton-main--38M16","layout":"InlineButton-layout--3OEum","icon":"InlineButton-icon--2MDYS","label":"InlineButton-label--1bYiU","hiddenLabel":"InlineButton-hiddenLabel--2KCZf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InlineButton/InlineButton.scss
// module id = k3R6
// module chunks = 4